import React, { Component } from 'react';

class Changelog extends Component {

    componentDidMount() {

    }

    render() {
        return (
            <div className="container  content">

                <div className="jumbotron jumbotron-fluid">
                    <div className="container">
                        <h2>17-07-2026</h2>
                        <p className="lead"># - Concept exporteren</p>
                        <p className="lead"># - Beschikbaarheid van gebruikers exporteren</p>
                        <p className="lead"># - Heatmap kleur aanpassing</p>
                    </div>
                </div>

            </div>
        );

    }
}


export default Changelog;
